export default {
  isSquarespace: () => {
    const iterator = document.createNodeIterator(document.head, NodeFilter.SHOW_COMMENT, filterNone, false)
    let curNode = iterator.nextNode()

    while (curNode) {
      if (curNode.nodeValue === ' This is Squarespace. ') {
        return true
      }
      curNode = iterator.nextNode()
    }
  },
  isWix: () => {
    const metaNode = document.querySelector('meta[name="generator"]')

    if (metaNode) {
      return metaNode.content === 'Wix.com Website Builder'
    }
  },
  isWeebly: () => {
    if (window._W) {
      return true
    }
  },
  isShopify: () => {
    if (window.Shopify) {
      return true
    }
  }
}

const filterNone = () => {
  return NodeFilter.FILTER_ACCEPT
}
